var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#096047;}\n\t.st1{fill:#C41E4A;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#E03258;}\n\t.st4{fill:#F45671;}\n\t.st5{fill:#A50C3B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    id: "XMLID_25_",
    points: "59,88.1 59,99.5 70.4,99.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    id: "XMLID_24_",
    points: "308.9,338 308.9,346.4 317.3,346.4  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M444.1,506H92.6c-4.9,0-9-4-9-9V15c0-4.9,4-9,9-9h351.5c4.9,0,9,4,9,9V497    C453,502,449,506,444.1,506z",
    id: "XMLID_23_"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    height: 471.2,
    id: "XMLID_22_",
    width: 340.7,
    x: 98,
    y: 20.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_189_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_204_"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    height: 11.2,
    id: "XMLID_205_",
    width: 244.2,
    x: 146.2,
    y: 86.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_202_"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    height: 11.2,
    id: "XMLID_203_",
    width: 244.2,
    x: 146.2,
    y: 109.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_200_"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    height: 11.2,
    id: "XMLID_201_",
    width: 244.2,
    x: 146.2,
    y: 132.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_198_"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    height: 11.2,
    id: "XMLID_199_",
    width: 244.2,
    x: 146.2,
    y: 155.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_196_"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    height: 11.2,
    id: "XMLID_197_",
    width: 244.2,
    x: 146.2,
    y: 178.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_194_"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    height: 11.2,
    id: "XMLID_195_",
    width: 244.2,
    x: 146.2,
    y: 201.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_192_"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    height: 11.2,
    id: "XMLID_193_",
    width: 244.2,
    x: 146.2,
    y: 225.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_190_"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    height: 11.2,
    id: "XMLID_191_",
    width: 180.4,
    x: 146.2,
    y: 248.2
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    id: "XMLID_5_",
    points: "286.3,156 286.3,6 409.7,6 409.7,156 348,119.8   "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    id: "XMLID_4_",
    points: "368.3,321.4 98,321.4 98,447.6 368.3,447.6 325.6,384.5   "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    id: "XMLID_3_",
    points: "344.7,333.8 98,333.8 98,435.3 344.7,435.3 310.3,384.6   "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    id: "XMLID_2_",
    points: "270.4,20.4 286.3,20.4 286.3,6   "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_124_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M138.9,392.4v24.6h-10.8v-65H153c7.2,0,12.8,1.9,16.9,5.6c4.1,3.7,6.1,8.6,6.1,14.6     c0,6.1-2,11-6.1,14.7c-4.1,3.7-9.7,5.5-16.9,5.5H138.9z M138.9,383.7H153c4,0,7-1.1,9.1-3.2c2-2.1,3-4.9,3-8.2c0-3.3-1-6.1-3-8.3     c-2-2.2-5-3.3-9.1-3.3h-14.1V383.7z",
    id: "XMLID_130_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M189,417.1v-65h21.5c8.2,0,14.9,2.6,20.1,7.7c5.2,5.1,7.7,11.8,7.7,19.9v9.9     c0,8.1-2.6,14.7-7.7,19.9c-5.2,5.1-11.9,7.7-20.1,7.7H189z M199.9,360.8v47.6h10.6c5.2,0,9.3-1.8,12.4-5.3     c3.1-3.5,4.6-8.1,4.6-13.6v-10c0-5.5-1.5-10-4.6-13.5c-3.1-3.5-7.2-5.3-12.4-5.3H199.9z",
    id: "XMLID_127_"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M290.1,389.3h-26.2v27.7H253v-65h41.6v8.7h-30.8v19.9h26.2V389.3z",
    id: "XMLID_125_"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.6b6fda5e67b84e22f60c3dd47ff279d1.svg";
export { ForwardRef as ReactComponent };